// src/components/CompanySelectionPage.jsx
import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Paper,
  Button,
  Stack,
  Fade,
  Backdrop,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BusinessIcon from '@mui/icons-material/Business';

export default function CompanySelectorModal({
  open,
  onClose,
  companies = [],
  onSelect,
}) {
  const username = sessionStorage.getItem('loggedInUsername') || 'Usuario';

  const handleSelect = (value) => {
    if (onSelect) {
      onSelect(value);
    }
  };

  const canSelectAll = Array.isArray(companies) && companies.length > 1;

  return (
    <Modal
      open={open}
      onClose={() => { }} // se fuerza selección; si quieres permitir cierre, usa onClose()
      closeAfterTransition
      disableEscapeKeyDown
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 300,
        sx: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            outline: 'none',
          }}
        >
          <Paper
            elevation={10}
            sx={{
              position: 'relative',
              px: 4,
              py: 5,
              borderRadius: '1.5rem',
              backdropFilter: 'blur(12px)',
              WebkitBackdropFilter: 'blur(12px)',
              backgroundColor: 'rgb(255, 255, 255)',
              border: '1px solid rgba(255,255,255,0.3)',
              boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
              minWidth: 400,
              maxWidth: 500,
              textAlign: 'center',
            }}
          >
            {/* Si quieres forzar selección, puedes ocultar este botón */}
            <IconButton
              onClick={onClose}
              sx={{
                position: 'absolute',
                top: 12,
                right: 12,
                color: '#fff',
                backgroundColor: 'rgba(0,0,0,0.3)',
                padding: '3px',
                '& svg': { fontSize: 17 },
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.5)',
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            <Typography variant="h6" fontWeight="bold" mb={1}>
              Bienvenido: {username}
            </Typography>
            <Typography variant="body1" mb={2}>
              Selecciona una empresa
            </Typography>

            {Array.isArray(companies) && companies.length > 0 ? (
              <Stack spacing={2}>
                {canSelectAll && (
                  <Button
                    onClick={() => handleSelect('ALL')}
                    variant="outlined"
                    sx={{
                      borderRadius: '2rem',
                      fontWeight: 600,
                      textTransform: 'none',
                      borderColor: '#0655A5',
                      color: '#0655A5',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 1,
                      '&:hover': {
                        borderColor: '#044a91',
                        backgroundColor: 'rgba(6,85,165,0.06)',
                      },
                    }}
                  >
                    <BusinessIcon sx={{ fontSize: 20 }} />
                    Todas las empresas
                  </Button>
                )}

                {companies.map((company) => (
                  <Button
                    key={company.EMPRESAID}
                    onClick={() => handleSelect(company)}
                    variant="contained"
                    sx={{
                      borderRadius: '2rem',
                      backgroundColor: '#0655A5',
                      fontWeight: 600,
                      textTransform: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 1,
                      '&:hover': {
                        backgroundColor: '#044a91',
                      },
                    }}
                  >
                    <BusinessIcon sx={{ fontSize: 20 }} />
                    {company.NOMBRE_EMPRESA || company.nombre}
                  </Button>
                ))}
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary" mt={2}>
                No hay empresas disponibles
              </Typography>
            )}

            <Typography
              variant="caption"
              color="text.secondary"
              mt={3}
              display="block"
              sx={{ fontSize: 12 }}
            >
              <strong style={{ color: 'red' }}>*</strong> Para continuar, selecciona una empresa
            </Typography>
          </Paper>
        </Box>
      </Fade>
    </Modal>
  );
}